module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-editor"
  }, [_c('h2', [_vm._v("Tags")]), _vm._v(" "), _vm._l((_vm.tagsDefinitions), function(ref) {
    var tag = ref[0];
    var tagDefinition = ref[1];

    return _c('div', [_c('div', {
      staticClass: "tag-definition",
      style: ({
        'background-color': tagDefinition.color
      })
    }, [_vm._v(_vm._s(tag) + "\n      "), _c('i', {
      staticClass: "material-icons delete",
      on: {
        "click": function($event) {
          _vm.deleteTagDefinition(tag)
        }
      }
    }, [_vm._v("close")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": tagDefinition.color
      },
      on: {
        "change": function($event) {
          _vm.setTagDefinition(tag, $event.target.value)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "add-tag-definition"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    attrs: {
      "placeholder": "add tag",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newTag)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTagDefinition(_vm.newTag)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTag = $event.target.value
      }
    }
  }), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    on: {
      "click": function($event) {
        _vm.addTagDefinition(_vm.newTag)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49288d01","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagsEditor.vue
// module id = 554
// module chunks = 1